import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, info) {
    console.error('[NRK] Error:', error, info);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ padding: 40, fontFamily: 'sans-serif', textAlign: 'center', background: '#fff', minHeight: '100vh' }}>
          <div style={{ fontSize: 48, marginBottom: 16 }}>warning</div>
          <h1 style={{ color: '#d32f2f', fontSize: 22 }}>Something went wrong</h1>
          <p style={{ color: '#666', marginTop: 8 }}>{this.state.error?.message || 'Unknown error'}</p>
          <button onClick={() => window.location.reload()} style={{ marginTop: 24, padding: '12px 24px', fontSize: 16, cursor: 'pointer', borderRadius: 8, border: 'none', background: '#1a3d16', color: '#fff' }}>Reload Page</button>
        </div>
      );
    }
    return this.props.children;
  }
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <ErrorBoundary>
    <App />
  </ErrorBoundary>
);